// extracted by mini-css-extract-plugin
export default {"box":"RawValidator_box__PY6t7","label":"RawValidator_label__7iGRH","subLabel":"RawValidator_subLabel__EnRzS"};